import * as XLSX from 'xlsx';

import { saveAs } from 'file-saver';

export const exportToExcel = (data: any[], filename = 'export.xlsx') => {
  const worksheet = XLSX.utils.json_to_sheet(data);

  const colWidths = Object.keys(data[0] || {}).map((key) => {
    const maxLength = data.reduce((max, row) => {
      const val = row[key];
      const len = val ? val.toString().length : 0;
      return Math.max(max, len);
    }, key.length);

    return { wch: maxLength + 2 };
  });

  worksheet['!cols'] = colWidths;


  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');

  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });

  saveAs(blob, filename);
};